import { EndorsementRulesQueryVariables } from '../gql/graphql';
import { getPaginatedNodes } from './utils';
import { graphql } from '../gql';
import { sortByOrder } from '@converge/utils';
import { useMemo } from 'react';
import { useQuery } from '@apollo/client';

export enum UnderwritingEndorsementType {
  PH_ONE = 'PH_ONE',
  PH_TWO = 'PH_TWO',
  ALL = 'ALL',
}

export const GET_ENDORSEMENTS = graphql(`
  query endorsementRules(
    $filters: EndorsementFilterInput!
    $pagination: PaginationRequest
    $sort: PaginationSort
  ) {
    endorsementRules(filters: $filters, pagination: $pagination, sort: $sort) {
      pageInfo {
        totalResults
        hasNextPage
        hasPreviousPage
        pageNumber
        pageSize
      }
      edges {
        cursor
        node {
          uuid
          type
          name
          primary
          excess
          nonPremiumBearing
          order
          description
          quote {
            uuid
            included
          }
          questions {
            edges {
              node {
                isRequired
                order
                parent
                question
                section
                sectionUuid
                subGroupUuid
                subSection
                subSectionUuid
                type
                uuid
                groupUuid
                answer {
                  answer
                  createdAt
                  type
                  updatedAt
                  uuid
                }
              }
            }
          }
          createdAt
          updatedAt
          coverageUuid
        }
        cursor
        queryCursor
      }
      pageInfo {
        totalResults
        hasNextPage
        hasPreviousPage
        pageNumber
        pageSize
      }
    }
  }
`);

export function useGetEndorsementsQuery({
  sort = { key: 'order', order: 'ASC' },
  pagination,
  filters,
}: EndorsementRulesQueryVariables) {
  const { loading, error, data } = useQuery(GET_ENDORSEMENTS, {
    variables: {
      sort,
      pagination,
      filters,
    },
  });
  const endorsements = useMemo(
    () => getPaginatedNodes(data?.endorsementRules).sort(sortByOrder),
    [data]
  );

  return {
    error,
    loading,
    data: data,
    endorsements,
  };
}
